// * This component is extremely similar to our Regular Link component, but is only used for internallinks / links we always want to open in a same tab
// * The reason this exists as its own component is because we CANNOT use the gatsby link (Gatsby link is only for links to pages that exist in this website), and we still require the promoCode tracking func, so we cannot use a regular A tag

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { StyledLink } from './styles';

function PromoLink({
  id,
  className,
  children,
  to,
  ariaLabel,
  queryString,
  noSpan,
}) {
  const child = noSpan ? children : <span>{children}</span>;

  const setParameters = (string) => {
    if (queryParameters.length > 0) {
      const queryParameter = queryParameters.join('&');
      return `${string}/?${queryParameter}`;
    }
    return string;
  };

  const [queryParameters, setQueryParameters] = useState([]);
  // * When the page first mounts we check for a filterQuery in the url
  useEffect(() => {
    if (typeof document !== 'undefined' && queryString) {
      const params = new URL(document.location).searchParams;
      const queries = queryString.split(',');
      queries.forEach((query) => {
        const key = query.trim();
        const queryParam = params.get(key);
        if (queryParam) {
          setQueryParameters((prevState) => {
            const newState = [...prevState, `${key}=${queryParam}`];
            return newState;
          });
        }
      });
    }
  }, []);

  return (
    <StyledLink
      id={id}
      className={className}
      href={setParameters(to)}
      aria-label={ariaLabel}
    >
      {child}
    </StyledLink>
  );
}

PromoLink.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  to: PropTypes.string,
  ariaLabel: PropTypes.string,
  noSpan: PropTypes.bool,
  queryString: PropTypes.string,
};

PromoLink.defaultProps = {
  id: null,
  className: null,
  to: '/',
  ariaLabel: null,
  noSpan: false,
  queryString: null,
};

export default PromoLink;
